export {
  default as mixedSpace,
  ReactComponent as MixedSpace,
} from '@assets/icons/features-and-amenities/mixed-space.svg'    
